<template>
    <div class="ReMapLocation row">
        <yandex-map
            :settings="settings"
            :coords="value"
            :zoom="zoom"
            :controls="controls"
            @map-was-initialized="mapInit"
            @click="mapClick"
			class="px-3"
        >
            <ymap-marker 
                :coords="value" 
                marker-id="main_marker" 
            />
			
        </yandex-map>
        <span v-if="debug">Выбраны координаты: {{ value.join(',') }}</span>
    </div>
</template>
<script>
import { yandexMap, ymapMarker, loadYmap } from 'vue-yandex-maps';
import { Select, Option } from 'element-ui';
// import { BaseCheckbox, BaseRadio } from 'src/components/index';
// import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
// import ReInputMetro from "src/our_components/ReInputMetro.vue";

import mapSettings from 'src/conf/yandexmap.js';

export default {
    name: 'ReMapLocation',
    components: {
        yandexMap, ymapMarker,
        [Option.name]: Option,
		[Select.name]: Select,
		// BaseCheckbox,
		// ReInputSearchDrop,
		// BaseRadio,
		// ReInputMetro,
    },
    props:{
        value:{
            type: Array,
            default(){
                return [59.93984485554249, 30.314527237792984]
            }
        },
        debug:{
            type: Boolean,
            default: false,
        },
        /**
         * Настройки карты
         */
        settings:{
            type: Object,
            default(){
                return mapSettings
				/*{
                    apiKey: '7f037fcc-21f0-4c1b-ad6e-1f292ef45a2f',
                    lang: 'ru_RU',
                    coordorder: 'latlong',
                    version: '2.1'
                }*/

            },
        },
        /**
         * величина зума (приближения) при её создании
         */

		zoom:{
            type: Number,
            default: 16,
        },
        /**
         * Список активных элементов в карте
         *  */        
		controls:{
            type: Array,
            default(){return ['zoomControl','typeSelector','searchControl']},
        },
    },
    data(){
        return {
            map:null,
        };
    },
	computed:{
		markerOptions(){
			return {
				preset:"islands#grayCircleDotIcon",
			};
		},
	},
    watch:{
		value:{
			handler(value){
                // console.log(value);
				this.$emit('input', value);
			},
			deep: true,
		}
    },
    methods:{
		onbNotOnMap(e){
			// this.bNotOnMap = e;
		},
        mapClick(e) {
            this.value = e.get('coords');
			this.OnCoordChange();
        },
        mapInit(myMap){
            this.map=myMap;
            let searchControl = myMap.controls.get('searchControl');
            searchControl.events.add('resultselect', e=>{
                this.value= e.originalEvent.target.getResultsArray()[e.get('index')].geometry._coordinates;
                this.OnCoordChange();
            }, this);
        },
		OnCoordChange(){
			const coord=this.value;
		},
    },
    async mounted() {
        // console.log('init LoadMapLocation');
        await loadYmap(this.settings);
    }
}
</script>

<style scoped> 

</style>